import { render, staticRenderFns } from "./RmaModal.vue?vue&type=template&id=3a591f41"
import script from "./RmaModal.vue?vue&type=script&lang=js"
export * from "./RmaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports